import { render, staticRenderFns } from "./Crisis_detail.vue?vue&type=template&id=8ff545ca&scoped=true"
import script from "./Crisis_detail.vue?vue&type=script&lang=js"
export * from "./Crisis_detail.vue?vue&type=script&lang=js"
import style0 from "./Crisis_detail.vue?vue&type=style&index=0&id=8ff545ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff545ca",
  null
  
)

export default component.exports